import * as yup from 'yup'

const schemaDepartment = (isEdit) => {
  return yup.object().shape({
    purchaserToken: yup.string().required(),
  })
}

export default schemaDepartment
